import {computed, defineComponent, onMounted, reactive, ref} from '@vue/composition-api';
import {i18n} from '@/utilities/vue-i18n';
import axios from 'axios';
import {SettingsContext} from '@/utilities/settings-context';
import {CompanyInfo} from './company-info-types';
import {
  validatePostCode,
  validateUrl
} from '@/functions/validation-functions';
import TransitionSlide from '@/components/transition-slide/transition-slide.vue'
import {alertDialogue, generalError} from '@/functions/system-modal-functions';
import {VueAvatar} from "vue-avatar-editor-improved";
import {createPageContext} from "@/components/navbar-box/page-context";
import stringify from "json-stable-stringify";
import {ModalIconType} from "@/components/system-modals/system-modals";
import { validateFullName, validatePhone, validateEmail } from '@noordigitalagency/accounts-ledigajobb';

export default defineComponent({

  components: {
    TransitionSlide,
    VueAvatar
  },

  setup(_, context) {

    const svg =
        '<?xml version="1.0" encoding="UTF-8"?>\n' +
        '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n' +
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"  width="192" height="80" viewBox="0 0 240 100">\n' +
        '\t<style type="text/css">\n' +
        '\t\t.st0{fill:#888A8B;}\n' +
        '\t</style>\n' +
        '\t<g>\n' +
        '\t\t<path class="st0" d="M87.1,61.3H74V38.7h2v20.8h11V61.3z"/>\n' +
        '\t\t<path class="st0" d="M90.4,50c0-1.7,0.3-3.3,0.9-4.7c0.6-1.4,1.4-2.7,2.4-3.7c1.1-1.1,2.3-1.9,3.7-2.5c1.4-0.6,3-0.9,4.7-0.9\n' +
        '\t\t\tc1.7,0,3.3,0.3,4.7,0.9s2.7,1.4,3.7,2.5c1.1,1.1,1.9,2.3,2.5,3.7c0.6,1.4,0.9,3,0.9,4.7s-0.3,3.3-0.9,4.7c-0.6,1.4-1.4,2.7-2.5,3.7\n' +
        '\t\t\tc-1.1,1.1-2.3,1.9-3.7,2.5s-3,0.9-4.7,0.9c-1.7,0-3.3-0.3-4.7-0.9c-1.4-0.6-2.7-1.4-3.7-2.5c-1.1-1.1-1.9-2.3-2.4-3.7\n' +
        '\t\t\tC90.7,53.3,90.4,51.7,90.4,50z M92.5,50c0,1.9,0.4,3.6,1.2,5.1c0.8,1.5,2,2.7,3.4,3.5s3.1,1.3,5,1.3c1.9,0,3.5-0.4,5-1.3\n' +
        '\t\t\tc1.5-0.9,2.6-2,3.4-3.5c0.8-1.5,1.2-3.2,1.2-5.1s-0.4-3.6-1.2-5.1c-0.8-1.5-2-2.7-3.4-3.5c-1.5-0.9-3.1-1.3-5-1.3\n' +
        '\t\t\tc-1.9,0-3.5,0.4-5,1.3s-2.6,2-3.4,3.5C92.9,46.4,92.5,48.1,92.5,50z"/>\n' +
        '\t\t<path class="st0" d="M116.9,50c0-1.7,0.3-3.3,0.9-4.7c0.6-1.4,1.4-2.7,2.4-3.7c1-1.1,2.3-1.9,3.7-2.4s3-0.9,4.7-0.9\n' +
        '\t\t\tc3.3,0,6,1,8.2,3.1l-1.5,1.4c-1.8-1.7-4-2.6-6.6-2.6c-1.9,0-3.5,0.4-5,1.3c-1.5,0.9-2.6,2-3.4,3.5c-0.8,1.5-1.3,3.2-1.3,5.1\n' +
        '\t\t\tc0,1.9,0.4,3.6,1.2,5.1c0.8,1.5,2,2.7,3.4,3.5s3,1.3,4.9,1.3c1.6,0,3.1-0.4,4.4-1.1c1.3-0.7,2.4-1.8,3.2-3c0.8-1.3,1.2-2.8,1.3-4.4\n' +
        '\t\t\th-8.7v-1.9h10.8c0,0.4,0,0.8,0,1.2c0,2.2-0.5,4.1-1.4,5.8c-0.9,1.7-2.2,3-3.9,3.9c-1.7,0.9-3.6,1.4-5.7,1.4c-1.7,0-3.2-0.3-4.6-0.9\n' +
        '\t\t\ts-2.6-1.4-3.7-2.5c-1-1.1-1.8-2.3-2.4-3.7C117.2,53.3,116.9,51.7,116.9,50z"/>\n' +
        '\t\t<path class="st0" d="M142.5,50c0-1.7,0.3-3.3,0.9-4.7c0.6-1.4,1.4-2.7,2.4-3.7c1.1-1.1,2.3-1.9,3.7-2.5s3-0.9,4.7-0.9\n' +
        '\t\t\ts3.3,0.3,4.7,0.9s2.7,1.4,3.7,2.5c1.1,1.1,1.9,2.3,2.5,3.7c0.6,1.4,0.9,3,0.9,4.7s-0.3,3.3-0.9,4.7c-0.6,1.4-1.4,2.7-2.5,3.7\n' +
        '\t\t\tc-1.1,1.1-2.3,1.9-3.7,2.5s-3,0.9-4.7,0.9s-3.3-0.3-4.7-0.9s-2.7-1.4-3.7-2.5c-1.1-1.1-1.9-2.3-2.4-3.7\n' +
        '\t\t\tC142.8,53.3,142.5,51.7,142.5,50z M144.6,50c0,1.9,0.4,3.6,1.2,5.1c0.8,1.5,2,2.7,3.4,3.5c1.5,0.9,3.1,1.3,5,1.3\n' +
        '\t\t\tc1.9,0,3.5-0.4,5-1.3c1.5-0.9,2.6-2,3.4-3.5c0.8-1.5,1.2-3.2,1.2-5.1s-0.4-3.6-1.2-5.1c-0.8-1.5-2-2.7-3.4-3.5\n' +
        '\t\t\tc-1.5-0.9-3.1-1.3-5-1.3c-1.9,0-3.5,0.4-5,1.3c-1.5,0.9-2.6,2-3.4,3.5C145,46.4,144.6,48.1,144.6,50z"/>\n' +
        '\t</g>\n' +
        '</svg>';

    const avatar = ref();

    const controls = ref();

    const model = reactive({ company: null as null | CompanyInfo });

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const settings = reactive({
      companyId: null as number | null,
      editingDetails: false,
      ratio: 1,
      logoWidth: 300,
      avatarWidth: 120,
      logoHeight: computed(() => settings.logoWidth * settings.ratio),
      avatarScale: computed(() => (settings.avatarWidth - 10) / settings.avatarWidth),
      avatarHeight: computed(() => settings.avatarWidth * settings.ratio),
      save: ''
    });

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const shadow = reactive({
      name: {
        valid: computed(() => typeof (model.company?.name) === 'string' && model.company?.name !== '')
      },
      general: {
        streetAddress: {
          valid: computed(() => typeof (model.company?.companyAddress?.streetAddress) === 'string' && model.company?.companyAddress?.streetAddress !== '')
        },
        postNumber: {
          valid: computed(() => typeof (model.company?.companyAddress?.postNumber) === 'string' && validatePostCode(model.company?.companyAddress?.postNumber))
        },
        postArea: {
          valid: computed(() => typeof (model.company?.companyAddress?.postArea) === 'string' && model.company?.companyAddress?.postArea !== '')
        },
        contactPerson: {
          valid: computed(() => typeof (model.company?.contactPerson) === 'string' && validateFullName(model.company?.contactPerson))
        },
        telephone: {
          valid: computed(() => typeof (model.company?.telephone) === 'string' && validatePhone(model.company?.telephone))
        },
        contactEmail: {
          valid: computed(() => typeof (model.company?.contactEmail) === 'string' && validateEmail(model.company?.contactEmail as string))
        },
        homePage: {
          valid: computed(() => model.company?.homePage == null || model.company?.homePage === '' || validateUrl(model.company?.homePage))
        },
        valid: computed(() => shadow.general.streetAddress.valid && shadow.general.postNumber.valid && shadow.general.postArea.valid && shadow.general.contactPerson.valid && shadow.general.telephone.valid && shadow.general.contactEmail.valid && shadow.general.homePage.valid)
      },
      invoice: {
        streetAddress: {
          valid: computed(() => model.company?.paperBilling === false || (typeof (model.company?.billingAddress?.streetAddress) === 'string' && model.company?.billingAddress?.streetAddress != ''))
        },
        postNumber: {
          valid: computed(() => model.company?.paperBilling === false || (typeof (model.company?.billingAddress?.postNumber) === 'string' && validatePostCode(model.company?.billingAddress?.postNumber)))
        },
        postArea: {
          valid: computed(() => model.company?.paperBilling === false || (typeof (model.company?.billingAddress?.postArea) === 'string' && model.company?.billingAddress?.postArea != ''))
        },
        invoiceEmail: {
          valid: computed(() => model.company?.paperBilling === true || (typeof (model.company?.invoiceEmail) === 'string' && validateEmail(model.company?.invoiceEmail as string)))
        },
        valid: computed(() => shadow.invoice.streetAddress.valid && shadow.invoice.postNumber.valid && shadow.invoice.postArea.valid && shadow.invoice.invoiceEmail.valid)
      },
      valid: computed(() => shadow.name.valid && shadow.general.valid && shadow.invoice.valid)
    });

    const getCompany = async () => {

      model.company = (await axios.get<CompanyInfo>(SettingsContext.getApiUrl('getCompany'), {params: {id: settings.companyId}})).data;

      if(model.company) {
          if(!model.company.billingAddress) {
            model.company.billingAddress = {
                postAddress: '',
                postCountry: '',
                coAddress: '',
                postArea: '',
                postNumber: '',
                streetAddress: '',
            };
          }
          if(!model.company.companyAddress) {
              model.company.companyAddress = {
                postAddress: '',
                postCountry: '',
                coAddress: '',
                postArea: '',
                postNumber: '',
                streetAddress: '',
            };
          }
      }

      settings.save = stringify(model.company);
    }

    onMounted(async () => {

      if (context.root.$route.params.company) {

        settings.companyId = parseInt(context.root.$route.params.company) as number;

        await getCompany();

        const image = (model.company as CompanyInfo).logo;

        if (image) {

          avatar.value.loadImage(image);
        }
      }
    });

    const browse = () => avatar.value.clicked();

    const deleteLogo = () => {

      avatar.value.resetImage()
      avatar.value = null;
      
      if (model.company) {
        model.company.logo = null;
      }
      
    };

    const imageReady = () => {

      const resource = avatar.value.state.image.resource as CanvasImageSource;

      let width = resource.width as number;

      let height = resource.height as number;

      const w = settings.logoWidth;

      const h = settings.logoHeight;

      const scale = Math.min(w / width, h / height);

      if (scale !== 1)
      {
        width *= scale;

        height *= scale;
      }
      
      const canvas = document.createElement('canvas') as HTMLCanvasElement;

      canvas.width = w;

      canvas.height = h;

      const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

      ctx.fillStyle = 'rgba(255, 0, 255, 0)';

      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.drawImage(resource, (w - width) / 2, (h - height) / 2, width, height);

      const imageData = canvas.toDataURL('image/png', 1.0);

      if (scale !== 1){
        avatar.value.resetImage();
      }

      setTimeout(() => {
        if (scale !== 1){
          avatar.value.loadImage(imageData);
        }

        (model.company as CompanyInfo).logo = imageData;

      }, 50);
    };

    const pageContext = createPageContext({

      actions: [],

      controls: controls,

      breadcrumb: {
        showHome: false,
        segments: [
          {text: i18n.t('home.breadcrumb-settings') as string, route: `/${context.root.$route.params.company}/settings`, icon: '<i class="mdi mdi-office-home-cog"></i>'},
          {text: i18n.t('pages.company-info.heading') as string, icon: '<i class="mdi mdi-domain"></i>' }
        ]
      },

      title: {text: ''}
    });

    const update = async () => {

      try {

        await axios.post(SettingsContext.getApiUrl('updateCompany'), {id: settings.companyId, ...model.company});

        await getCompany();

        settings.editingDetails = false;

        await alertDialogue(i18n.t('pages.company-info.info-updated') as string,  i18n.t('pages.company-info.info-success') as string, ModalIconType.info);

      }
      catch {
        await generalError(true);
      }

    };

    const cancel = () => {

      const backup = JSON.parse(settings.save) as CompanyInfo;

      if (backup.logo && backup.logo.trim().length > 0) {

        avatar.value.loadImage(backup.logo);
      }
      else
      {
        avatar.value.resetImage();
      }

      model.company = backup;

      settings.editingDetails = false;
    };

    return {

      model,

      settings,

      svg,

      avatar,

      browse,

      deleteLogo,

      imageReady,

      shadow,

      controls,

      pageContext,

      update,

      cancel
    };
  }
})
